import { BrowserRouter as Router } from "react-router";
import './App.css'
import AppRoutes from './routes/AppRoutes';
import { ToastProvider } from "./components/ToastProvider/ToastProvider";

function App() {
  
  return (
    <>
      <ToastProvider>
        <Router>
          <AppRoutes />
        </Router>
      </ToastProvider>
    </>
  );
}

export default App
